import { constants } from '../common/constants/constants';
import { LANGUAGE_CODES } from '../common/constants/languageCodes';

export const LANDING_VIN_PARAM = 'landingVin';
// set by "Get FULL Access" on the landing VIN page: the visitor has seen the preview and goes straight to the plans
export const FULL_ACCESS_PARAM = 'fullAccess';

// The landing has the same locales as the app, and redirects a bare-VIN slug to the canonical one,
// so the app does not need to know the slug formula.
export const getLandingVehiclePageUrl = (vin, language) => {
    const lang = language?.slice(0, 2);
    const locale = Object.values(LANGUAGE_CODES).includes(lang) ? lang : LANGUAGE_CODES.ENGLISH;

    return `${constants.LANDING_BASE_URL}/${locale}/vin/${encodeURIComponent(vin.toLowerCase())}`;
};

// The landing preview page (blurred report) for a car that is in the base. Its "Get FULL Access" comes back
// with FULL_ACCESS_PARAM, which goes on to the plans.
export const openLandingVehiclePage = (vin, language) => {
    window.location.assign(getLandingVehiclePageUrl(vin, language));
};

// The landing hand-off params that have to survive the sign-in pages on their way to the dashboard.
export const getLandingVinQuery = searchParams => {
    const landingVin = searchParams.get(LANDING_VIN_PARAM);

    if (!landingVin) {
        return '';
    }

    const query = new URLSearchParams({ [LANDING_VIN_PARAM]: landingVin });

    if (searchParams.get(FULL_ACCESS_PARAM) === 'true') {
        query.set(FULL_ACCESS_PARAM, 'true');
    }

    return `?${query.toString()}`;
};
